import React from "react";
import Particles from "react-particles-js";
import Progress from "components/progress";
import { Row, Col } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faGithub,
  faLinkedin,
  faTwitter,
  faYoutube,
} from "@fortawesome/free-brands-svg-icons";
import ThemeContext from "../../context";
import "./styles.scss";

class Hero extends React.Component {
  static contextType = ThemeContext;

  render() {
    return (
      <section
        id={`${this.props.id}`}
        className="about"
        style={{ height: this.context.height }}
      >
        {this.particles()}
        <Row>
          <Col md={6} className="content">
            <div className="content-text">
              <div className="line-text">
                <h4>About Me</h4>
              </div>
              <h3>I'm a Front-end developer</h3>
              <div className="separator" />
              <p>
                With over 8 years of experience in Front End Development,i have
                successfully completed projects for clients such as; Invictus
                Capital, Quantfury, Isuzu, Nedbank, GMSA, TFG, Standard Bank,
                Sasfin Bank, South African Tourism, Truworths, Momentum, Rand
                Gold and Investec. I have been previously employed at companies
                such as NATIVE VML, Caxton Digital, MAINGAMING and B4SHAW
                Development Studio and Woolworths. My experience has provided me
                with the innovative and technical skills necessary to
                successfully provide you with multifaceted technical solutions
                across a wide range of software platforms.
              </p>
              <div className="social social_icons">
                <FontAwesomeIcon
                  icon={faGithub}
                  className="social_icon"
                  onClick={() => window.open("https://github.com/Munei89")}
                />
                <FontAwesomeIcon
                  icon={faLinkedin}
                  className="social_icon"
                  onClick={() =>
                    window.open("https://www.linkedin.com/in/munei-nengwenani/")
                  }
                />
              </div>
            </div>
          </Col>
          <Col md={6} className="skills">
            <div className="line-text">
              <h4>My Skills</h4>
            </div>
            <div className="skills-container">
              <Progress
                name="Web Design(Adobe,Zeplin)"
                value={70}
                delay={1100}
              />
              <Progress name="Angular" value={50} delay={1100} />
              <Progress
                name="React Typescript/Javascript"
                value={80}
                delay={1100}
              />
              <Progress name="Redux" value={80} delay={1100} />
              <Progress name="MongoDB" value={40} delay={1100} />
              <Progress name="HTML/CSS" value={80} delay={1100} />
              <Progress name="Headless CMS" value={70} delay={1100} />
              <Progress name="Wordpress" value={70} delay={1100} />
              <Progress name="Jest" value={70} delay={1100} />
              {/* Webpack */}
            </div>
          </Col>
        </Row>
      </section>
    );
  }

  particles() {
    return (
      <Particles
        className="particles"
        params={{
          particles: {
            number: {
              value: 50,
              density: {
                enable: false,
                value_area: 5000,
              },
            },
            line_linked: {
              enable: true,
              opacity: 0.5,
            },
            size: {
              value: 1,
            },
          },
          retina_detect: true,
        }}
      />
    );
  }
}

export default Hero;
